import useGet from './useGet';

export default useGet;
